import { useState } from "react";
import { TrendingTitlesTable, TopTitlesTable, DistributionViews } from "../dashboardReports";
import LineGraph from "../EngagementGraph";
import "./index.css"
import { Select } from "antd";

const timeframeOptions = [
    {
        id: 1,
        label: "Last 60 Minutes",
        value: "60:min"
    },
    {
        id: 2,
        label: "Last 6 Hours",
        value: "6:hours"
    },
    {
        id: 3,
        label: "Last 24 Hours",
        value: "24:hours"
    },
    {
        id: 4,
        label: "Last 7 Days",
        value: "7:days"
    },
    {
        id: 5,
        label: "Last 30 Days",
        value: "30:days"
    }
]

const { Option } = Select;
const Overview = () => {
    const [graphType, setGraphType] = useState("views")
    const [title, setTitle] = useState("");
    const [granularity, setGranularity] = useState("60:min")

    const getGraphType = (graph) => {
        setGraphType("title")
        setTitle(graph)
    }

    const handleGranularityChange = (value) => {
        setGranularity(value);
    }

    return (
        <div className="container">
            <div className="container-wrapper">
                <div className="heading">Engagement</div>

                <Select
                    value={granularity}
                    onChange={handleGranularityChange}
                    style={{ width: 150, backgroundColor: "#ffff" }}
                    className="time-selector"
                >
                    {timeframeOptions.map((each) => {
                        return (
                            <Option
                                key={each.value}
                                value={each.value}
                                style={{ backgroundColor: "#ffff" }}
                            >
                                {each.label}
                            </Option>
                        );
                    })}
                </Select>
            </div>

            <LineGraph graphType={graphType} title={title} granularity={granularity} />
            <div className="dashboard-reports-wrapper">
                <TrendingTitlesTable getGraphType={getGraphType} />
                <TopTitlesTable getGraphType={getGraphType} granularity={granularity} />
            </div>
            <div style={{ Width: "48%", maxWidth: "48%", marginLeft: "20px", marginTop: "60px" }}>
                <DistributionViews graphType={graphType} title={title} granularity={granularity} />
            </div>
        </div>
    )
}

export default Overview
